import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class LetterCodeListVm {
	letterCodeId: number;
	letterCodeName?: string;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'letterCodeId': new UntypedFormControl(0, [...(validators['letterCodeId'] ?? []), ...[Validators.required]]),
			'letterCodeName': new UntypedFormControl(null, [...(validators['letterCodeName'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['letterCodeName', {"orderId":0,"sortColumn":"letterCodeName","searchColumn":"letterCodeName","includeInExcel":true,"exportColumn":null,"displayName":"Letter Code","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":1,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":false,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): LetterCodeListVmFromFg {
		return new LetterCodeListVmFromFg(fg);
	}
}

export class LetterCodeListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get letterCodeId(): number {
		return this.fg.get('letterCodeId').value;
	}
	set letterCodeId(val) {
		this.fg.get('letterCodeId').setValue(val);
	}

	get letterCodeName(): string {
		return this.fg.get('letterCodeName').value;
	}
	set letterCodeName(val) {
		this.fg.get('letterCodeName').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
